// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"343":"7a781a42","486":"4c0a084b","592":"d3a64294"}[chunkId] + ".chunk.js";
};